import React from 'react';
import PropTypes from 'prop-types';
import {computed} from 'mobx';
import {observer} from 'mobx-react';

import {withI18n} from 'spa/Components/Context';
import {PAYMENT_INSTRUMENT_BRANDS} from '../../state/payments/billing';

import '../CheckoutPaymentDetails/checkout-payment-details.less';

import visa from 'spa/images/icons/visa.svg';
import mastercard from 'spa/images/icons/mastercard.svg';
import amex from 'spa/images/icons/amex.svg';
import na from 'spa/images/icons/na.svg';

@observer
@withI18n
class CardOptionItem extends React.Component {
  static propTypes = {
    cardInfo: PropTypes.shape({
      cardLast4: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      paymentInstrumentBrand: PropTypes.string.isRequired,
    }).isRequired,
    disabled: PropTypes.bool,
    onChangeToken: PropTypes.func.isRequired,
    paymentInfo: PropTypes.shape({
      paymentToken: PropTypes.string.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    disabled: false,
  };

  @computed get cardIcon() {
    const {cardInfo} = this.props;

    if (
      cardInfo.paymentInstrumentBrand === PAYMENT_INSTRUMENT_BRANDS.AMEX ||
      cardInfo.paymentInstrumentBrand === PAYMENT_INSTRUMENT_BRANDS.AMERICAN_EXPRESS
    ) {
      return <img src={amex} alt="" />;
    } else if (cardInfo.paymentInstrumentBrand === PAYMENT_INSTRUMENT_BRANDS.VISA) {
      return <img src={visa} alt="" />;
    } else if (cardInfo.paymentInstrumentBrand === PAYMENT_INSTRUMENT_BRANDS.MASTERCARD) {
      return <img src={mastercard} alt="" />;
    }

    return <img src={na} alt="" />;
  }

  render() {
    const {i18n} = this.context;
    const {
      cardInfo,
      disabled,
      onChangeToken,
      paymentInfo,
    } = this.props;
    const {cardIcon} = this;

    return (
      <label className="checkout-payment-details__payment-method" key={cardInfo.id}>
        <div className="checkout-payment-details__payment-method--cover" />
        <input
          type="radio"
          name="payment-token"
          value={cardInfo.id}
          onChange={onChangeToken}
          checked={paymentInfo.paymentToken === cardInfo.id}
          disabled={disabled}
          data-qa={`card-select-${cardInfo.cardLast4}`}
        />
        <span className="checkout-payment-details__payment-method-icon">
          {cardIcon}
        </span>
        <span className="checkout-payment-details__payment-method-label" data-qa="card-last-4-text">
          {i18n._x('ending in %(last4)s', 'Gifts Checkout Payment Details', {
            last4: cardInfo.cardLast4,
          })}
        </span>
      </label>
    );
  }
}

export default CardOptionItem;



// WEBPACK FOOTER //
// ./spa/Components/AddPaymentMethod/CardOptionItem.jsx